module.exports = __webpack_public_path__ + "img/004.1830f103.png";